import React, { useState } from 'react';
import CommonBudgetTable from './components/CommonBudgetTable';
import TransactionScreen from './screens/TransactionScreen';
import { allHeaderTab } from './utils/string';
import BudgetPlanning from './screens/BudgetPlanning';
import Header from './components/Header';
import FinancialDashboard from './screens/AnnualView';

function Main({ handeNavbarState }) {
  const [selectedTab, setSelectedTab] = useState(allHeaderTab.annualView);
  const [selectedMonthTab, setSelectedMonthTab] = useState({});
  const handleSelectedTab = (value) => {
    if (!(value === selectedTab)) {
      setSelectedMonthTab({});
      setSelectedTab(value);
    }

  }

  return (
    <div className="" style={{ marginTop: '-2%' }}>
      <Header handeNavbarState={handeNavbarState} selectedTab={selectedTab} setSelectedTab={handleSelectedTab} setSelectedMonthTab={setSelectedMonthTab} selectedMonthTab={selectedMonthTab} />
      <div style={{ marginTop: (window.innerWidth < 1220) ? '18%' : window.innerWidth > 1900 ? '7%' : '12%' }}>
        {(selectedTab === allHeaderTab.annualView) ? <FinancialDashboard /> : (selectedTab === allHeaderTab.budgetPlanning) ?
          <BudgetPlanning /> :
          <TransactionScreen monthlyTab={selectedMonthTab?.monthValue ?? ""} />
        }
      </div>
    </div>
  );
}

export default Main;
